// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CalmLiveAltLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 111 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M37.259 0h-26.12C5.098 0 .2 4.898.2 10.94v26.12C.2 43.102 5.097 48 11.14 48h26.12c6.042 0 10.94-4.898 10.94-10.94V10.94C48.2 4.898 43.301 0 37.26 0Z"
			fill="url(#CalmLiveAltLogo_tsx__a)"
		/>
		<path
			d="M37.259 0h-26.12C5.098 0 .2 4.898.2 10.94v26.12C.2 43.102 5.097 48 11.14 48h26.12c6.042 0 10.94-4.898 10.94-10.94V10.94C48.2 4.898 43.301 0 37.26 0Z"
			fill="url(#CalmLiveAltLogo_tsx__b)"
		/>
		<path
			d="M45.247 29.956a.291.291 0 0 0-.395-.113c-.305.169-1.32.508-1.64.623-1.204.197-2.677.152-3.403-1.605-.218-.529-.435-1.006-.809-1.505-.423-.564-1.807-1.24-3.1-.025a4.74 4.74 0 0 0-.799.988 7.71 7.71 0 0 0-.245.418 1.876 1.876 0 0 0-.015-.055c-.114-.394-.48-1.848-1.999-2.085-.209-.017-1.054-.112-2.224 1.171-.392.437-.749.904-1.066 1.398-.056-.261-.123-.498-.188-.602-.994-1.529-2.5-.308-3.148.148-1.453 1.02-2.127 2.393-3.01-.725a13.04 13.04 0 0 1-.276-1.34c.883-1.5 2.681-6.06 1.647-9.118-.068-.194-.427-1.181-1.29-1.118-.124.013-1.107-.09-1.646 2.657-.503 2.655-.392 6.078-.27 7.213.014.117.04.35.085.654-.852 1.455-1.969 3.11-2.65 3.187-.885.1-.639-.714-1.176-2.525-.094-.235-.392-1.354-1.734-1.298-.658.027-1.35.198-2.3 1.235-1.54 1.685-5.053 4.22-7.566 2.626-.273-.211-1.63-1.32-1.128-4.646.152-.915.423-1.807.806-2.652.369-.826.832-1.605 1.38-2.324 2.581-3.17 4.817-3.54 5.259-3.521 1.13 0 1.425 1.465 1.424 1.45a.47.47 0 1 0 .931-.09 2.57 2.57 0 0 0-.19-.92c-.178-.577-.689-1.112-.985-1.31-1.418-.987-4.62-.191-7.721 3.387a12.554 12.554 0 0 0-1.621 2.64c-.448.977-.764 2.01-.941 3.072-.84 5.895 2.749 6.832 3.36 6.947 3.146.367 5.463-1.345 6.558-2.395.394 1.968 2.362 1.992 3.225 1.103.22-.234.4-.503.534-.795.511 1.86 2.15 1.227 2.343 1.144.914-.342 1.87-1.614 2.545-2.681.429 1.463 1.258 3.03 2.85 2.862.959-.023 3.364-2.579 3.586-2.245.222.275.282.782.266 1.538-.016.756.586.794.858.719.42-.117.685-.944 1.125-1.664.269-.452.585-.875.944-1.26.172-.185.953-.993 1.505-.718.551.274.607.837.645 1.15.038.311.043.643.056 1.006-.016 1.252.572 1.429.738 1.475 1.361.367 1.446-2.19 2.446-3.14.094-.097.966-.998 1.464.47.72 2.655 2.934 3.647 5.915 2.171.552-.273.661-.38.963-.605a.29.29 0 0 0 .077-.372Zm-29.159-.539c-.594 1.223-1.904 1.15-1.886-.184.02-1.364 1.72-2.225 2.178-1.274.036.081.065.166.087.252-.08.251-.111.656-.379 1.206Zm7.321-11.501c.25.464.79 3.37-.682 6.548a30.32 30.32 0 0 1-.01-.304c-.012-5.163.644-6.334.692-6.244ZM55.747 20.058h1.903v9.005h4.548v1.692h-6.451V20.058ZM64.974 20.058h1.903v10.697h-1.903V20.058ZM69.419 20.058h2.13l2.946 8.234h.06l2.977-8.234h2.055l-4.291 10.697h-1.647l-4.23-10.697ZM81.974 20.058h7.086v1.662h-5.182v2.72h4.91v1.6h-4.91v3.023h5.454v1.692h-7.358V20.058Z"
			fill="#fff"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M102.723 18.796a6.524 6.524 0 1 1 0 13.048 6.524 6.524 0 0 1 0-13.048Zm0-1.553a8.078 8.078 0 1 1 0 16.156 8.078 8.078 0 0 1 0-16.156Zm0 12.738a4.66 4.66 0 1 0 0-9.322 4.66 4.66 0 0 0 0 9.322Z"
			fill="url(#CalmLiveAltLogo_tsx__c)"
		/>
		<defs>
			<linearGradient
				id="CalmLiveAltLogo_tsx__a"
				x1={24.2}
				y1={48}
				x2={24.2}
				y2={0}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#3478DD" />
				<stop offset={1} stopColor="#3BBEEC" />
			</linearGradient>
			<linearGradient
				id="CalmLiveAltLogo_tsx__b"
				x1={0.118}
				y1={69.344}
				x2={26.647}
				y2={19.391}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#793BEB" />
				<stop offset={1} stopColor="#793BEB" stopOpacity={0} />
			</linearGradient>
			<linearGradient
				id="CalmLiveAltLogo_tsx__c"
				x1={102.215}
				y1={33.417}
				x2={101.721}
				y2={17.268}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#3ABBEB" />
				<stop offset={1} stopColor="#BCE808" />
			</linearGradient>
		</defs>
	</svg>
);
export default CalmLiveAltLogo;
